import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Thu Sep 13 2018
 * @author VBr
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { action, observable, runInAction } from 'mobx';
import { StoreName } from '../StoreName';
import { BaseStore } from '../BaseStore';
import { ProductSensitivityLayer } from '../../transportLayers/product/ProductSensitivityLayer';
/**
 * This store obtaining data of product categories.
 */

export var ProductSensitivityStore =
/*#__PURE__*/
function (_BaseStore) {
  _inherits(ProductSensitivityStore, _BaseStore);

  function ProductSensitivityStore(rootStore) {
    var _this;

    _classCallCheck(this, ProductSensitivityStore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ProductSensitivityStore).call(this, rootStore));
    _this.name = StoreName.ProductSensitivity;
    _this.productSensitivityLayer = new ProductSensitivityLayer();
    _this.list = new Map();
    return _this;
  }
  /**
   * Will fetch all data for this page
   */


  _createClass(ProductSensitivityStore, [{
    key: "getAll",
    value: function getAll() {
      var _this2 = this;

      return this.productSensitivityLayer.findAll().then(function (sensitivities) {
        runInAction(function () {
          sensitivities.forEach(function (sensitivity) {
            if (sensitivity.id) {
              _this2.list = _this2.list.set(sensitivity.id, sensitivity);
            }
          });
        });
        return _this2.list;
      });
    }
  }, {
    key: "getOne",
    value: function getOne(sensitivityId) {
      var _this3 = this;

      return this.productSensitivityLayer.findOne(sensitivityId).then(function (productSensitivity) {
        runInAction(function () {
          _this3.list = _this3.list.set(productSensitivity.id, productSensitivity);
        });
        return productSensitivity;
      });
    }
  }]);

  return ProductSensitivityStore;
}(BaseStore);

__decorate([observable, __metadata("design:type", Map)], ProductSensitivityStore.prototype, "list", void 0);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", Promise)], ProductSensitivityStore.prototype, "getAll", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", Promise)], ProductSensitivityStore.prototype, "getOne", null);